import React from "react";
import styled from "styled-components";

const StyledMain = styled.main`
  overflow: auto;
  margin: 0 auto;
  z-index: 1;
`;

export default function RouteWrapper(props) {
  return <StyledMain>{props.children}</StyledMain>;
}
